<template>
  <div>

    <lk-form slot='content' :model='goodsForm' :rules='validate' :label-width='134'
      label-position="right" ref="goodsForm">
      <div class="cardContainer">

        <lk-card title='基础商品信息'>

          <!-- 商品最开始验证部分 -->

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='通用名:' prop='approvedDrugNames' ref="approvedDrugNames">
                <div v-if="able">
                  <goodsDropDownInput 
                    v-if='isAdd &&isInStore' 
                    :type='2' 
                    v-model.trim="goodsForm.approvedDrugNames" 
                    @selected='handleSelect'  
                    @on-blur='setMnemonicCode'>
                  </goodsDropDownInput>
                  <lk-input  
                    @on-change='setMnemonicCode(goodsForm.approvedDrugNames)'   
                    v-model.trim="goodsForm.approvedDrugNames" 
                    :maxlength='40' 
                    v-else 
                    clearable 
                    placeholder="请输入">
                  </lk-input>
                </div>
                <span v-else>{{goodsForm.approvedDrugNames}}</span>
              </lk-form-item>
            </lk-col>


            <lk-col span='7' :offset='1'>
              <lk-form-item label='注册证号:' prop='approvalNumber'>

                <lk-input :maxlength='30' v-if="able"
                  :disabled='disabledSearch' placeholder="请输入"
                  v-model.trim="goodsForm.approvalNumber"></lk-input>
                <span
                  v-else>{{goodsForm.approvalNumber}}</span>

              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>
              <lk-form-item label='包装规格' prop='specifications'>
                <lk-input :maxlength='32' v-if="able" placeholder="请输入" :disable='isInStore&&disabledSearch'
                  v-model.trim="goodsForm.specifications"></lk-input>
                <span v-else>{{goodsForm.specifications}}</span>
              </lk-form-item>
            </lk-col>
  </lk-row>
          <lk-row :gutter="16">
            <lk-col span='7' >
              <lk-form-item label='包装单位:' prop='drugMiniPackageUnit'>
                <lk-select v-if="able" clearable
                  v-model.trim="goodsForm.drugMiniPackageUnit" :disabled='!isAdd || isImport'>
                  <lk-option v-for="(item,index) in baseData.drugMiniPackageUnitArr" :key="index"
                    :value='item. dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  <!-- <lk-option :value='1'>盒</lk-option> -->
                </lk-select>
                <span
                  v-else>{{goodsForm.drugMiniPackageUnitString}}</span>
              </lk-form-item>
            </lk-col>


            <lk-col span='7' :offset='1'>
              <lk-form-item label='生产企业:' prop='manufacturer'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.manufacturer"></lk-input>
                <span v-else>{{goodsForm.manufacturer}}</span>
              </lk-form-item>
            </lk-col>


            <lk-col span='7'  :offset='1'>
              <lk-form-item label='是否进口:' prop='isImport'>
                <lk-radio-group v-if="able" v-model.trim="goodsForm.isImport">
                  <lk-radio :label="1" :value="1" >是</lk-radio>
                  <lk-radio :label="2" :value="2" >否</lk-radio>
                </lk-radio-group>
                <span v-else>{{isImportArr[goodsForm.isImport]}}</span>
              </lk-form-item>
            </lk-col>
            </lk-row>
          <lk-row :gutter="16">
            <lk-col span='7'>
              <lk-form-item label='质检标准:' prop='drugAcceptanceStandard'>
                <lk-input :maxlength='50' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.drugAcceptanceStandard"></lk-input>
                <span v-else>{{goodsForm.drugAcceptanceStandard}}</span>
              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>

              <lk-form-item label='储存条件:' prop='storageConditions'>
                <div >

                  <lk-select v-if="able" clearable
                    v-model.trim="goodsForm.storageConditions"
                    @on-change='handleStorageConditions'
                    :class="{'other':goodsForm.storageConditions === 6}">
                    <lk-option v-for="(item,index) in baseData.storageConditionsArr" :key="index"
                      :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  </lk-select>
                  <lk-input :maxlength='10' style="width:60%" v-if="able && goodsForm.storageConditions === 6"
                    v-model.trim="goodsForm.otherStorage"></lk-input>

                  <span v-if='!able'>
                    <span>
                      {{goodsForm.storageConditionsStringNew}}
                    </span>
                  </span>
                </div>
              </lk-form-item>
              <lk-form-item v-if="able&&goodsForm.storageConditions > 0" prop='temp'>
                <div  class="fakeFormItem">
                    <label style="width:26px">温度：</label>
                    <lk-input-number v-model="goodsForm.minTemp" style="width:calc(50% - 25px)"
                    placeholder="最低温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                    <label style="margin:0 4px">-</label>
                    <lk-input-number v-model="goodsForm.maxTemp" style="width:calc(50% - 25px)"
                    placeholder="最高温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                  </div>
              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>
              <lk-form-item label='条形码:' prop='barCode'>
                <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.barCode"></lk-input>
                <span v-else>{{goodsForm.barCode}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>

          <lk-row :gutter='16'>

            <lk-col span='7' >
              <lk-form-item label='商品分类:' prop='indicationDicId'>
                <lk-cascader v-if="able" clearable :data="baseData.indicationTree"
                  v-model.trim="indicationDicArray"></lk-cascader>
                <span v-else>{{goodsForm.indicationDicString}}</span>
              </lk-form-item>
            </lk-col>
 <lk-col span='7' :offset='1'>
              <lk-form-item label='器械型号:' prop='model'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.model"></lk-input>
                <span v-else>{{goodsForm.model}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='是否数据直连:' prop='isDataLink'>
                <lk-radio-group v-if="able" clearable v-model.trim="goodsForm.isDataLink">
                  <lk-radio :label="1" :value="1">是</lk-radio>
                  <lk-radio :label="2" :value="2">否</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.isDataLink===1?'是':'否'}}</span>
              </lk-form-item>
            </lk-col>

          </lk-row>
            <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='说明书:' prop='manualUrl'>
                <Uploader :able='able' v-model='goodsForm.manualUrl'></Uploader>
                <!-- <span v-else>{{indicationDicString}}</span> -->
              </lk-form-item>
            </lk-col>
             <lk-col span='7' :offset='1'>
               <lk-form-item label='用法:' prop='goodsUsageName'>
                 <select-input v-if="able" v-model="goodsForm.goodsUsage"
                   :otherStr='goodsForm.otherGoodsUsage' :options='baseData.usageArr'
                   name='dictionaryName' keyName='dictionaryIndex' @setOther='val=>{goodsForm.otherGoodsUsage=val}'></select-input>
                 <span v-else>{{goodsForm.otherGoodsUsage||goodsForm.goodsUsageName}}</span>
               </lk-form-item>
             </lk-col>
             <lk-col span='7' :offset='1'>
               <lk-form-item label='频次:' prop='packers'>
                 <select-input v-if="able" v-model="goodsForm.frequency"
                   :otherStr='goodsForm.otherFrequency' :options='baseData.frequencyArr'
                   name='dictionaryName' keyName='dictionaryIndex' @setOther='val=>{goodsForm.otherFrequency=val}'></select-input>
                 <span v-else>{{goodsForm.otherFrequency||goodsForm.frequencyName}}</span>
               </lk-form-item>
             </lk-col>

          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='每次用量:' prop='dosage'>
                  <lk-input v-if="able" v-model='goodsForm.dosage' placeholder="请输入"></lk-input>
                <span v-else>{{goodsForm.dosage}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7'  :offset='1'>

              <lk-col span='24'>
                <lk-form-item label='药品图片:' prop='drugImageUrl'>

                  <Uploader :able='able' v-model.trim="goodsForm.drugImageUrl">
                  </Uploader>
                </lk-form-item>


              </lk-col>
            </lk-col>
            <lk-col span='7' :offset='1'>
               
                 <drugInstruction :approvalNumber='goodsForm.approvalNumber' :approvedDrugNames='goodsForm.approvedDrugNames'
                :manufacturer='goodsForm.manufacturer' :specifications='goodsForm.specifications'></drugInstruction>
               
            </lk-col>
          </lk-row>
          <lk-row :gutter='16' v-if="[25, 7, 3].indexOf($store.state.storeInfo.id) >= 0">
            <lk-col span='7'>
              <lk-form-item label='开启UDI管理:' prop='udiFlag'>
                <lk-radio-group v-if="able" clearable v-model.trim="goodsForm.udiFlag">
                  <lk-radio :label=1 :value=1>开启</lk-radio>
                  <lk-radio :label=2 :value=2>关闭</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.udiFlag===1?'开启':'关闭'}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">
        <lk-card title='商品标签'>


          <lk-row :gutter='16'>
            <lk-col span='7'>

              <lk-form-item label='GSP管理分类:' class="storeSelect" prop='gspIdList'>
                <lk-select v-if="able" v-model="goodsForm.gspIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.gspArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.gsps }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>

              <lk-form-item label='经营范围:' class="storeSelect" prop='bizIdList'>
                <lk-select v-if="able" v-model="goodsForm.bizIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.bizArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.bizs }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>

              <lk-form-item label='生产范围:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.prodIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.prodArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.prods }}</span>
              </lk-form-item>
            </lk-col>


          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>

              <lk-form-item label='其他:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.otherIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.otherArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.others }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <div class="cardContainer">

        <lk-card title='证件信息'>
          <lk-form :label-width='130' label-position="right" :model='goodsForm'
            ref="groupCheck" :rules='groupCheck'>
            <lk-row :gutter='16'>
              <lk-col class="backGroundCard" span='7'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='prodLicenseUrl'>
                      <div class="label withPic">
                        <label>生产许可证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.prodLicenseUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='prodLicenseCode'>
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.prodLicenseCode"></lk-input>
                      <span v-else>{{goodsForm.prodLicenseCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodProdLicense'>
                      <expire-picker :able='able' :type='1' v-model.trim="goodsForm.periodProdLicense"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>


              <lk-col class="backGroundCard" span='7' :offset='1'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='drugRegApprovalUrl'>
                      <div class="label withPic">
                        <label>产品注册证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.drugRegApprovalUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='drugRegApprovalCode'>
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.drugRegApprovalCode"></lk-input>
                      <span v-else>{{goodsForm.drugRegApprovalCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodDrugRegApproval'>
                      <expire-picker :able='able' v-model.trim="goodsForm.periodDrugRegApproval"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>

              <lk-col class="backGroundCard" span='7' :offset='1'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='inspectionReportUrl'>
                      <div class="label withPic">
                        <label>检验报告书:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.inspectionReportUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='inspectionReportCode'>
                      <lk-input :maxlength='20' v-if="able"
                        v-model.trim="goodsForm.inspectionReportCode"></lk-input>
                      <span v-else>{{goodsForm.inspectionReportCode}}</span>
                    </lk-form-item>
                  </lk-col>

                </lk-row>
              </lk-col>
              </lk-row>
            <!-- <lk-row :gutter='16'>
              <lk-col span='7'>
                <lk-form-item prop='drugImageUrl'>
                  <div class="label withPic">
                                    <label>药品图片:</label>
                                  </div>
                                  <Uploader :able='able' v-model.trim="goodsForm.drugImageUrl">
                                  </Uploader>
                </lk-form-item>
              </lk-col>
            </lk-row> -->

          </lk-form>
        </lk-card>
      </div>
    </lk-form>


  </div>
</template>

<script>
import Uploader from '../../Uploader.vue';
import ExpirePicker from '../../expireInfo/expirePicker.vue';
import goodsDropDownInput from '../goodsDropDownInput.vue';
import SelectInput from '../../selectInput.vue';
import drugInstruction from '../../drugInstruction.vue' //药品说明书

export default {
  name: 'GoodsBase',
  components: {
    SelectInput,
    Uploader,
    goodsDropDownInput,
    ExpirePicker,
    drugInstruction
  },
  props: {
    info: {
      type: Object,
      // required: true,
    },
    able: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },

    isInStore: {
      type: Boolean,
      default: false,
    },
    isImport: {
      type: Boolean,

    },
    isFromBaseInfo: { // 药品类型和消杀类型的时间等是非必填
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'info',
    event: 'change',

  },
  computed: {
    isAdd() {
      return !this.$route.params.id;
    },
    disabledSearch() {
      return !!this.$route.params.id || this.isImport;
    },
  },
  watch: {
    info: {
      handler() {
        console.log(this.info);

        this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];
        this.goodsForm = this.info;
      },
      deep: true,
    },
    goodsForm: {
      handler() {
        this.firstCheck();
        this.$emit('change', this.goodsForm);
      },
      deep: true,
    },
    indicationDicArray: {
      handler(val) {
        if (val && val.length) {
          this.goodsForm.indicationDicId = val[val.length - 1];
          this.goodsForm.indicationDicArray = val.join(',');
        } else {
          this.goodsForm.indicationDicId = null;
          this.goodsForm.indicationDicArray = '';
        }
      },
      deep: true,
    },
  },

  data() {
    return {
      disableExistsTest: false,
      isImportArr: ['', '是', '否'],
      groupCheck: {
        periodProdLicense: [{
          required: !this.isFromBaseInfo, message: '请选择有效期', trigger: 'change', type: 'number',

        }],
      },
      validate: {
        approvalNumber: [
          { required: true, message: '请输入注册证号', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
          // { validator: utils.validate.approvalNumberValidator, trigger: 'change' },
        // { validator: codeTest, trigger: 'change' },
        ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        drugMiniPackageUnit: [
          { 
            required: true, type: 'number', message: '请输入包装单位', trigger: 'change' 
          },
          {
            validator: this.ifSelectDrugMiniPackageUnit, trigger: 'change'
          }
        ],
        approvedDrugNames: [
          { required: true, message: '请输入通用名', trigger: 'blur' },
        ],
        udiFlag: [
          { required: false, message: '', trigger: 'blur' },
        ],
      },
      // inExists: true,
      // disabledSearch: false,
      goodsForm: {
        isImport: 2,
        storageConditions: 1,
        minTemp: null,
        maxTemp: null,
        udiFlag: 2,
      },
      firstFill: {},
      indicationDicArray: [],

    };
  },
  methods: {
    handleStorageConditions(val) {
      if (val === 1) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 2) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 3) {
        this.goodsForm.minTemp = 0;
        this.goodsForm.maxTemp = 20;
      } else if (val === 4) {
        this.goodsForm.minTemp = 2;
        this.goodsForm.maxTemp = 8;
      } else if (val === 5) {
        this.goodsForm.minTemp = -25;
        this.goodsForm.maxTemp = -20;
      } else {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      }
    },
    firstCheck() {
      this.goodsForm.approvedDrugNames && (this.$refs.approvedDrugNames.validateState = '');// 强制清除验证状态

      if (this.isInStore && !(this.goodsForm.approvalNumber || this.goodsForm.specifications || this.goodsForm.approvedDrugNames)) {
        this.disableExistsTest = true;
        let firstFill = null;
        ['approvedDrugNames',
          'approvalNumber',
          'specifications',
        ].forEach((item) => {
          this.$refs.goodsForm.validateField(item, (msg) => {
            console.log(msg);
            if (msg) {
              firstFill = msg;
            }
          });
        });
        if (firstFill) {
          this.$Message.error('请先填写商品通用名 和 注册证号 和 规格');
        }
        this.disableExistsTest = false;
      }
    },
    setMnemonicCode(name) {
      this.$emit('setMnemonicCode', name);
    },
    handleSelect(data) {
      console.log(data);
      this.$emit('import', data);
    },
    validateForm(isSubmit) {
      this.$emit('change', this.goodsForm);
      return new Promise((resolve) => {
        let validate = true;
        this.disableExistsTest = true;
        if (isSubmit) {
          this.$refs.goodsForm.validate((goodsFormValid) => {
            this.$refs.groupCheck.validate((groupCheckValid) => {
              resolve(goodsFormValid && groupCheckValid);
              this.disableExistsTest = false;
            });
          });
        } else {
          [
            'approvalNumber',
            'specifications',
            'approvedDrugNames',
            'drugMiniPackageUnit'
          ].forEach((item) => {
            this.$refs.goodsForm.validateField(item, (msg) => {
            // console.log(msg);
              if (msg) {
                validate = false;
              }
            });
          });
          this.$nextTick(() => {
            this.disableExistsTest = false;
            resolve(validate);
          });
        }
      });
    },

    testTemp(rule, value, callback) {
      if (this.goodsForm.maxTemp != null && this.goodsForm.minTemp != null && this.goodsForm.maxTemp <= this.goodsForm.minTemp) {
        callback(
          new Error('最高温度应大于最低温度'),
        );
      }
      if (this.goodsForm.storageConditions === 6) {
        if (this.goodsForm.maxTemp === null && this.goodsForm.minTemp === null) {
          callback(
            new Error('当前储存条件下，温度必填'),
          );
        } else callback();
      } else if (this.goodsForm.storageConditions > 2) {
        if (this.goodsForm.maxTemp === null || this.goodsForm.minTemp === null) {
          callback(
            new Error('请输入完整温度范围'),
          );
        } else callback();
      } else callback();
    },
    testOtherStorage(rule, value, callback) {
      if (this.goodsForm.storageConditions === 6 && !this.goodsForm.otherStorage) {
        callback(
          new Error('请输入储存条件名称'),
        );
      } else {
        callback();
      }
    },
    existsTest(rule, value, callback) {
      if (!this.disabledSearch && this.goodsForm.approvalNumber && this.goodsForm.specifications && !this.disableExistsTest) {
        this.$emit('change', this.goodsForm);

        const temp = {
          approvalNumber: this.goodsForm.approvalNumber,
          specifications: this.goodsForm.specifications,
        };
        // temp.specifications = temp.specifications.split(' ').join('');


        this.$emit('handleExist', temp);
      }
      callback();
    },
    ifSelectDrugMiniPackageUnit(rule, value, callback) {
      if(!this.goodsForm.drugMiniPackageUnit) {
        callback(new Error('请选择计量单位'));
      } else {
        callback();
      }
    }
  },

  created() {
    if (this.isInStore) {
      this.validate = {
        approvedDrugNames: [
          { required: true, message: '请输入通用名', trigger: 'blur' },
        ],
        approvalNumber: [
          { required: true, message: '请输入注册证号', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],

        temp: [{ required: true, validator: this.testTemp, trigger: 'blur' }],
        gspIdList: [{
          required: true, message: '请选择GSP管理分类', trigger: 'change', type: 'array',
        }],
        bizIdList: [{
          required: true, message: '请选择药品经营范围', trigger: 'change', type: 'array',
        }],

        isDataLink: [
          {
            required: true, message: '请选择是否数据直连', trigger: 'change', type: 'integer',
          },
        ],

        drugMiniPackageUnit: [
          {
            required: true, message: '请选择包装单位', trigger: 'change', type: 'number',
          },
        ],
        storageConditions: [
          {
            required: true, message: '请选择储存条件', trigger: 'change', type: 'number',
          },
          { validator: this.testOtherStorage, trigger: 'blur' },
        ],

        manufacturer: [
          { required: true, message: '请输入生产企业', trigger: 'change' },
        ],

        qualityOfDrugsType: [
          {
            required: true, message: '请选择质检分类', trigger: 'change', type: 'number',
          },
        ],
        drugAcceptanceStandard: [
          { required: true, message: '请输入质检标准', trigger: 'change' },
        ],
        prodLicenseCode: [{
          required: true, message: '请填写证件号', trigger: 'change',
        }],
        periodProdLicense: [{
          required: !this.isFromBaseInfo, message: '请选择有效期', trigger: 'change', type: 'number',

        }],
        gmpCertCode: [{ required: true, message: '请填写证件号', trigger: 'change' }],
        // periodGmpCert: [{
        //   required: true, message: '请选择有效期', trigger: 'change', type: 'number',
        // }],

      };
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.goodsForm = this.info;
      this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];
    }
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }

  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
   .fakeFormItem{
    margin-left: -36px
  }
  .other{
    width: 40%;
  }
</style>
